import { styled } from 'styled-components'

export const CenteredContentContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`
